import { Formik } from 'formik'
import React from 'react'
import { SignUpFormValues } from './SignUpForm.interface'
import { SignUpSchema } from './SignUpForm.validator'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { Typography } from '@mui/material'
import Logo from 'src/assets/images/gigsafe-logo-black.svg'
import { GetHelp } from 'src/components/shared/GetHelp'

const initialValues: SignUpFormValues = {
  password: '',
  confirmPassword: '',
}

interface Props {
  isLoading?: boolean
  onSubmit: (values: SignUpFormValues) => void
}

export const SignUpForm = ({ isLoading, onSubmit }: Props) => {
  return (
    <div css={tw`bg-white rounded-3xl p-4 flex pb-12`}>
      <div css={tw`w-[326px] mx-6`}>
        <div css={tw`flex items-center justify-between mt-4`}>
          <img src={Logo} />
          <GetHelp />
        </div>
        <Typography variant="h2" css={tw`mb-2 mt-16`}>
          Create your password
        </Typography>
        <Typography color="#847E96" css={tw`mt-2 mb-4 w-[280px]`}>
          Securely log in with your login and password to manage your fleet.
        </Typography>
        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={SignUpSchema}>
          {({ handleSubmit }) => (
            <div css={tw`w-full`}>
              <FormikTextField
                name="password"
                type="password"
                label="Create password"
                css={tw`w-full mb-6`}
                placeholder="Enter new password"
              />
              <FormikTextField
                name="confirmPassword"
                type="password"
                label="Repeat password"
                css={tw`w-full mb-6`}
                placeholder="Repeat new password"
              />
              <Button
                className={tw`w-full`}
                variant="contained"
                loading={isLoading}
                onClick={() => handleSubmit()}
              >
                Create password
              </Button>
            </div>
          )}
        </Formik>
      </div>
    </div>
  )
}
